module.exports = __webpack_public_path__ + "assets/img/lipu_2.520df981.png";